import { render, staticRenderFns } from "./IdcCreateEditCustomer.vue?vue&type=template&id=5bc32216&scoped=true&"
import script from "./IdcCreateEditCustomer.vue?vue&type=script&lang=js&"
export * from "./IdcCreateEditCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc32216",
  null
  
)

export default component.exports